export const MEGA_API = "https://extapp.gwsvc.de/JBWeb.svc";
export const LOT_POP = "/Drawings";
//export const MEGA_API = "http://app.barracuda.link:9293/JBWeb.svc"
// export const MEGA_API = "http://localhost:49801/JBWeb.svc";
export const Sistema_ID = 1;
export const SERIAL_PADRAO = "999000000001";

export const CONTEST_API = "https://extapp.gwsvc.de/";
export const NEW_DESIGN_LOT_POP =
  "api/ApuracaoRodada/Sorteios/ResultadoLoterias";
export const NEW_DESIGN_CONTEST = "api/ApuracaoRodada/Sorteios/Resultado";
export const NEW_DESIGN_SERIAL = "Postman";
export const NEW_DESIGN_SISTEMA_ID = 32;



// WEBPACK FOOTER //
// ./src/modules/constants.js